import React, { PropTypes } from 'react';
import RcRate from '../../_rc-rate-1.1.2';

export default class Rate extends React.Component {
  static propTypes = {
    prefixCls: PropTypes.string,
  };
  static defaultProps = {
    prefixCls: 'ant-rate',
  };
  render() {
    return <RcRate {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/rate/index.jsx